<div class="rounded-2xl border border-neutral-a4 bg-neutral-a2 p-6 shadow-2xs">
  <div class="flex flex-col sm:flex-row sm:items-center sm:justify-between gap-4">
    <div>
      <span class="text-xs font-semibold text-neutral-11 uppercase tracking-wider">Formule actuelle</span>
      <h2 class="text-2xl font-extrabold text-neutral-12 mt-1 tracking-tight">
        {{ planName() }}
      </h2>
    </div>

    <div class="flex flex-wrap items-center gap-2">
      <aura-subscription-status-chip [status]="status()" />

      @if (cancelAtPeriodEnd() && !isExpired()) {
        <span
          class="rounded-full px-2.5 py-0.5 text-xs font-semibold flex items-center gap-1.5 border bg-amber-3 text-amber-11 border-amber-5"
        >
          <span class="h-1.5 w-1.5 rounded-full bg-amber-9 animate-pulse"></span>
          Annulation différée
        </span>
      }
    </div>
  </div>

  @if (isExpired()) {
    <div
      class="mt-5 w-full rounded-xl border border-crimson-a5 bg-crimson-a2 p-4 flex items-center gap-3 text-sm text-crimson-12 leading-relaxed"
    >
      <span class="material-icons text-crimson-11 text-xl shrink-0">error_outline</span>
      <div class="min-w-0 flex-1 whitespace-normal break-words">
        <span class="font-bold">Abonnement expiré</span> {{ humanizedRelativeEnd() }} (le
        {{ currentPeriodEnd() | date: 'dd MMMM yyyy' : undefined : 'fr-FR' }}). Vos avantages premium ne sont
        plus actifs.
      </div>
    </div>
  } @else if (status() === 'past_due') {
    <div
      class="mt-5 w-full rounded-xl border border-amber-a5 bg-amber-a2 p-4 flex items-center gap-3 text-sm text-amber-12 leading-relaxed"
    >
      <span class="material-icons text-amber-11 text-xl shrink-0">payment</span>
      <div class="min-w-0 flex-1 whitespace-normal break-words">
        <span class="font-bold">Paiement en attente</span>. Le prélèvement de renouvellement a échoué.
        Veuillez mettre à jour votre moyen de paiement sur le portail de facturation pour conserver vos accès.
      </div>
    </div>
  } @else if (isExpiringSoon() && cancelAtPeriodEnd()) {
    <div
      class="mt-5 w-full rounded-xl border border-amber-a5 bg-amber-a2 p-4 flex items-center gap-3 text-sm text-amber-12 leading-relaxed"
    >
      <span class="material-icons text-amber-11 text-xl shrink-0">schedule</span>
      <div class="min-w-0 flex-1 whitespace-normal break-words">
        <span class="font-bold">Expiration imminente</span> : votre abonnement prendra fin
        {{ humanizedRelativeEnd() }} (le
        {{ currentPeriodEnd() | date: 'dd MMMM yyyy' : undefined : 'fr-FR' }}).
      </div>
    </div>
  }

  <mat-divider class="my-5" />

  <div class="grid grid-cols-1 sm:grid-cols-2 gap-6 text-sm">
    <div>
      <span class="text-xs text-neutral-11 font-medium block mb-1">Date de début</span>
      <span class="font-bold text-neutral-12">
        {{ currentPeriodStart() | date: 'dd MMMM yyyy' : undefined : 'fr-FR' }}
      </span>
    </div>

    <div>
      <span class="text-xs text-neutral-11 font-medium block mb-1">
        @if (isExpired()) {
          Date d'expiration
        } @else if (cancelAtPeriodEnd()) {
          Date de fin d'accès
        } @else {
          Prochain renouvellement
        }
      </span>
      <div class="flex items-center gap-2 flex-wrap">
        <span class="font-bold text-neutral-12">
          {{ currentPeriodEnd() | date: 'dd MMMM yyyy' : undefined : 'fr-FR' }}
        </span>
        @if (humanizedRelativeEnd(); as rel) {
          <span class="text-xs text-neutral-11 bg-neutral-a3 px-2 py-0.5 rounded-md font-medium">
            {{ rel }}
          </span>
        }
      </div>
    </div>
  </div>
</div>
